import { render, staticRenderFns } from "./apprenticebByLaws.vue?vue&type=template&id=46e0832f&scoped=true&"
import script from "./apprenticebByLaws.vue?vue&type=script&lang=js&"
export * from "./apprenticebByLaws.vue?vue&type=script&lang=js&"
import style0 from "./apprenticebByLaws.vue?vue&type=style&index=0&id=46e0832f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0832f",
  null
  
)

export default component.exports